import { FCX } from "@datassential/platform-ui-lib";
import { Link } from "react-router-dom";
import { IKeyTerm } from "@core/apiHooks/useSocialThemes";
import LazyImage from "@components/LazyImage/LazyImage";
import placeholderImg from "../../../img/image-placeholder.png";
import { getKeyTermLink } from "./KeyTerms.helpers";
import './KeyTerms.scss';

const MAX_VISIBLE_ITEMS = 10;
const COMPACT_MAX_VISIBLE_ITEMS = 5;
const DENSE_THRESHOLD = 8;

const KeyTerms: FCX<{
    data: IKeyTerm[];
    isCompact?: boolean;
    selectedThemeId?: number | null;
}> = ({ data, isCompact, selectedThemeId }) => {
    const maxItems = isCompact ? COMPACT_MAX_VISIBLE_ITEMS : MAX_VISIBLE_ITEMS;
    const isScrollable = data.length > maxItems;
    const isDense = data.length >= DENSE_THRESHOLD;

    return (
        <div className="KeyTerms" data-testid="blockKeyTerms">
            <div className="KeyTerms__header">KEY TERMS</div>
            {data.length === 0 ? (
                <div className="KeyTerms__no-data">We donut have feedback on this yet, it's still in the oven</div>
            ) : (
                <div className={`KeyTerms__scroll ${isScrollable ? 'is-scrollable' : ''} ${isDense ? 'is-dense' : ''}`}>
                    <div key={selectedThemeId} className="KeyTerms__list appears del-1">
                        {data.map((term) => (
                            <Link
                                key={term.id}
                                className="KeyTerms__card"
                                data-testid={`blockKeyTermsItem-${term.id}`}
                                to={getKeyTermLink(term)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <LazyImage
                                    className="KeyTerms__card-image"
                                    src={term.thumbnailUrl}
                                    alt={term.name}
                                    placeholder={<img src={placeholderImg as string} alt=""/>}
                                />
                                <div className="KeyTerms__card-overlay"/>
                                <div className="KeyTerms__card-content">
                                    <span className="KeyTerms__card-name">{term.name}</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default KeyTerms;
